import renderWrapper from './render-wrapper';
import MiniCart from '../Components/MiniCart/MiniCart';
import MiniCartButton from '../Components/MiniCart/MiniCartButton';
import StockStatus from '../Components/StockStatus/StockStatus';
import Checkout from '../Components/Checkout/Checkout';
import ProductFiltering from '../Components/ProductFiltering/ProductFiltering';
import ProductSorting from '../Components/ProductSorting/ProductSorting';
import BuyButton from '../Components/BuyButton/BuyButton';
import FilterBar from '../Components/FilterBar/FilterBar';
import MyPagesContainer from '../Components/MyPages/MyPagesContainer';
import Navigation from '../Components/Navigation/Navigation';
import ProductPageImageSlider from '../Components/ProductPageImageSlider/ProductPage.ImageSlider';
import BannerSliderBlock from '../Blocks/BannerBlock/BannerSliderBlock';
import BannerBlock from '../Blocks/BannerBlock/BannerBlock';
import ProductSlider from '../Blocks/ProductSlider';
import ProductListHeaderText from '../Components/ProductList.HeaderText';
import ActiveFilterChips from '../Components/ActiveFilterChips/ActiveFilterChips';
import ProductBlockNoSlider from '../Blocks/ProductBlockNoSlider';
import QuickSearch from '../Components/QuickSearch/QuickSearch';
import SearchResult from '../Components/SearchResult/SearchResult';
import SearchNavigation from '../Components/SearchResult/SearchNavigation';
import NavigationMobileTrigger from '../Components/Navigation/NavigationMobileTrigger';
import NavigationMobile from '../Components/Navigation/NavigationMobile';
import Overlay from '../Components/Overlay';
import VariantPickerDropdown from '../Components/VariantPicker/VariantPicker.Dropdown';
import VariantPickerButtons from '../Components/VariantPicker/VariantPicker.Buttons';
import LoginModal from '../Components/Login/LoginModal';
import LoginPage from '../Components/Login/LoginPage';
import LoginModalTrigger from '../Components/Login/LoginModalTrigger';
import Test from '../Components/Test';
import ProductListing from '../Components/ProductListing/ProductListing';
import PriceHistoryModalTrigger from '../Components/ProductPriceHistory/PriceHistoryModalTrigger';
import LinkBlock from '../Blocks/LinkBlock/LinkBlock';
import OrderConfirmation from '../Components/OrderConfirmation/OrderConfirmation';
import BrandsBlock from '../Blocks/BrandsBlock';
import EditorString from '../Components/EditorString/EditorString';
import RichTextBlock from '../Blocks/RichTextBlock';
import TopMessage from '../Components/TopMessage/TopMessage';
import FaqAccordion from '../Blocks/FaqAccordion';
import ResponsiveImage from '../Components/ResponsiveImage/ResponsiveImage';
import UspBlock from '../Blocks/UspBlock';
import ProductPageVariantList from '../Components/ProductPageVariantList/ProductPage.VariantList';
import ScrollToElementButton from '../Components/ScrollToElementButton/ScrollToElementButton';
import SubNavigationContainer from '../Components/SubNavigationContainer/SubNavigationContainer';
import ProductsAndBannerBlock from '../Blocks/ProductsAndBannerBlock';
import CookieConsent from '../Components/CookieConsent/CookieConsent';
import PriceHistoryModal from '../Components/ProductPriceHistory/PriceHistoryModal';
import CategoryNavigation from '../Components/ProductListing/CategoryNavigation';
import CategoryDescription from '../Components/ProductListing/CategoryDescription';
import HeaderSelectors from '../Components/HeaderSelectors/HeaderSelectors';
import PriceToggle from '../Components/PriceToggle/PriceToggle';
import PostnordLocation from '../Components/PostnordLocation/PostnordLocation';
import CustomerApplicationForm from '../Components/CustomerApplicationForm/CustomerApplicationForm';
import BrandNavigation from '../Components/BrandNavigation/BrandNavigation';
import CategoryBlock from '../Blocks/CategoryBlock/CategoryBlock';
import NavisionSingleBulkPrice from '../Components/NavisionPrice/ui/NavisionSingleBulkPrice';
import MyPagesInvoices from '../Components/MyPages/Invoices/MyPagesInvoices';
import MyPagesPriceLabels from '../Components/MyPages/MyPagesPriceLabels';
import MyPagesService from '../Components/MyPages/MyPagesService';
import MyPagesOrderApprover from '../Components/MyPages/MyPagesOrderApprover';
import ProductSpecification from '../Components/ProductPage/ProductSpecification';
import ProductMedia from '../Components/ProductPage/ProductMedia';
import StartPageSelectorModal from '../Components/StartPageSelectorModal';
import ImageRepositoryContainer from '../Components/ImageRepository/ImageRepositoryContainer';
import ProductPageItemBIDs from '../Components/ProductPage/ProductPageItemBIDs';
import InvoiceModal from '../Components/InvoiceModal/InvoiceModal';

global['Components'] = {
  ProductListing: (props) => renderWrapper(ProductListing, props),
  MiniCart: (props) => renderWrapper(MiniCart, props),
  MiniCartButton: (props) => renderWrapper(MiniCartButton, props),
  StockStatus: (props) => renderWrapper(StockStatus, props),
  ProductFiltering: (props) => renderWrapper(ProductFiltering, props),
  ProductSorting: (props) => renderWrapper(ProductSorting, props),
  MyPagesContainer: (props) => renderWrapper(MyPagesContainer, props),
  Checkout: (props) => renderWrapper(Checkout, props),
  BuyButton: (props) => renderWrapper(BuyButton, props),
  FilterBar: (props) => renderWrapper(FilterBar, props),
  QuickSearch: (props) => renderWrapper(QuickSearch, props),
  SearchResult: (props) => renderWrapper(SearchResult, props),
  SearchNavigation: (props) => renderWrapper(SearchNavigation, props),
  ProductBlockNoSlider: (props) =>
    renderWrapper(ProductBlockNoSlider, props),
  ProductListHeaderText: (props) =>
    renderWrapper(ProductListHeaderText, props),
  Navbar: (props) => renderWrapper(Navigation, props),
  ProductPageImageSlider: (props) =>
    renderWrapper(ProductPageImageSlider, props),
  BannerSliderBlock: (props) => renderWrapper(BannerSliderBlock, props),
  BannerBlock: (props) => renderWrapper(BannerBlock, props),
  ProductSlider: (props) => renderWrapper(ProductSlider, props),
  ActiveFilterChips: (props) => renderWrapper(ActiveFilterChips, props),
  NavigationMobileTrigger: (props) =>
    renderWrapper(NavigationMobileTrigger, props),
  NavigationMobile: (props) => renderWrapper(NavigationMobile, props),
  Overlay: (props) => renderWrapper(Overlay, props),
  VariantPickerDropdown: (props) =>
    renderWrapper(VariantPickerDropdown, props),
  VariantPickerButtons: (props) =>
    renderWrapper(VariantPickerButtons, props),
  LoginModal: (props) => renderWrapper(LoginModal, props),
  LoginPage: (props) => renderWrapper(LoginPage, props),
  LoginModalTrigger: (props) => renderWrapper(LoginModalTrigger, props),
  TopMessage: (props) => renderWrapper(TopMessage, props),
  OrderConfirmation: (props) => renderWrapper(OrderConfirmation, props),
  ProductsAndBannerBlock: (props) =>
    renderWrapper(ProductsAndBannerBlock, props),
  Test: (props) => renderWrapper(Test, props),
  LinkBlock: (props) => renderWrapper(LinkBlock, props),
  BrandsBlock: (props) => renderWrapper(BrandsBlock, props),
  EditorString: (props) => renderWrapper(EditorString, props),
  RichTextBlock: (props) => renderWrapper(RichTextBlock, props),
  FaqAccordion: (props) => renderWrapper(FaqAccordion, props),
  UspBlock: (props) => renderWrapper(UspBlock, props),
  ResponsiveImage: (props) => renderWrapper(ResponsiveImage, props),
  ProductPageVariantList: (props) =>
    renderWrapper(ProductPageVariantList, props),
  ScrollToElementButton: (props) =>
    renderWrapper(ScrollToElementButton, props),
  SubNavigationContainer: (props) =>
    renderWrapper(SubNavigationContainer, props),
  CookieConsent: (props) => renderWrapper(CookieConsent, props),
  PriceHistoryModalTrigger: (props) =>
    renderWrapper(PriceHistoryModalTrigger, props),
  PriceHistoryModal: (props) => renderWrapper(PriceHistoryModal, props),
  CategoryNavigation: (props) => renderWrapper(CategoryNavigation, props),
  CategoryDescription: (props) =>
    renderWrapper(CategoryDescription, props),
  HeaderSelectors: (props) => renderWrapper(HeaderSelectors, props),
  PriceToggle: (props) => renderWrapper(PriceToggle, props),
  PostnordLocation: (props) => renderWrapper(PostnordLocation, props),
  BrandNavigation: (props) => renderWrapper(BrandNavigation, props),
  CustomerApplicationForm: (props) =>
    renderWrapper(CustomerApplicationForm, props),
  CategoryBlock: (props) => renderWrapper(CategoryBlock, props),
  NavisionSingleBulkPrice: (props) =>
    renderWrapper(NavisionSingleBulkPrice, props),
  MyPagesInvoices: (props) => renderWrapper(MyPagesInvoices, props),
  MyPagesPriceLabels: (props) => renderWrapper(MyPagesPriceLabels, props),
  MyPagesService: (props) => renderWrapper(MyPagesService, props),
  MyPagesOrderApprover: (props) =>
    renderWrapper(MyPagesOrderApprover, props),
  ProductSpecification: (props) =>
    renderWrapper(ProductSpecification, props),
  ProductMedia: (props) => renderWrapper(ProductMedia, props),
  StartPageSelectorModal: (props) =>
    renderWrapper(StartPageSelectorModal, props),
  ImageRepositoryContainer: (props) =>
    renderWrapper(ImageRepositoryContainer, props),
  InvoiceModal: (props) => renderWrapper(InvoiceModal, props),
  ProductPageItemBIDs: (props) =>
    renderWrapper(ProductPageItemBIDs, props),
};
